import React, { createContext, useState, useContext, useCallback, useRef, useMemo } from 'react';
const DownloadsPanelContext = /*#__PURE__*/createContext(null);
export const DownloadsPanelContextProvider = ({
  children
}) => {
  const triggerButtonRef = useRef(null);
  const [isRefetching, setIsRefetching] = useState(false);
  const openDownloadsPanel = useCallback(() => {
    if (triggerButtonRef.current) {
      triggerButtonRef.current.click();
    }
  }, []);
  const contextValue = useMemo(() => ({
    triggerButtonRef,
    openDownloadsPanel,
    isRefetching,
    setIsRefetching
  }), [openDownloadsPanel, isRefetching, setIsRefetching]);
  return /*#__PURE__*/React.createElement(DownloadsPanelContext.Provider, {
    value: contextValue
  }, children);
};
export const useDownloadsPanelContext = () => {
  const context = useContext(DownloadsPanelContext);

  if (!context) {
    throw new Error('Could not find an DownloadsPanelContext. Have you wrapped the app with the DownloadsPanelContextProvider component?');
  }

  return context;
};